export default {
  title: 'Carga de matriz de convenios',

  uploadSpace: {
    placeholder: 'Arrastra y suelta el archivo aquí',
    placeholderDrag: 'Arrastra y suelta'
  },

  actions: {
    uploadFile: 'Subir archivo',
    uploadProviderServiceFile: 'Enviar matriz de servicios',
    uploadProviderProductFile: 'Enviar matriz de productos',
    replace: 'Reemplazar'
  },

  uploadHistoryGrid: {
    title: 'Historial de carga',
    tooltipDownload: 'Descargar archivo con listado de errores de formato',

    headers: {
      date: 'Fecha',
      file: 'Archivo',
      size: 'Peso',
      status: 'Estado',
      lastStatusUpdate: 'Fecha último estado',
      actions: 'Acciones'
    },

    statuses: {
      uploadPending: 'Carga en progreso',
      uploadError: 'Errores en la carga',
      uploadComplete: 'Carga completa',
      validationPending: 'Validación en progreso',
      validationError: 'Error en validación'
    },
  },

  messages: {
    uploadSuccess: 'La matriz se cargó exitosamente. Por favor, espera hasta que todas las configuraciones sean aplicadas. Esto puede tardar varios minutos',
    formatErrorsFound: 'El archivo no es válido, su formato no cumple con los requisitos esperados',
    invalidTypeFile: 'El tipo de archivo no es válido',
    downloadError: 'Error al descargar el archivo',
  },
}
